export const tableDataSchemas = [
  {
    prop: 'id',
    label: '唯一标识',
    minWidth: 150
  },
  // {
  //   prop: 'changeInfo',
  //   label: '变化信息组装说明',
  //   minWidth: 120
  // },
  {
    prop: 'operator',
    label: '操作人',
    minWidth: 60
  },
  {
    prop: 'createTime',
    label: '操作时间',
    minWidth: 60
  },
  {
    prop: 'action',
    label: '操作',
    btnArr: ['info']
  }
  // {
  //   prop: 'outParameterInfo',
  //   label: '外部传参记录信息',
  //   minWidth: 60
  // },
  // {
  //   prop: 'originalInfo',
  //   label: '原始记录信息',
  //   minWidth: 60
  // }
]
